// WRITTEN BY Claude Code (PLAI-8323)
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ActiveSessionService {
  hasValidToken(): boolean {
    if (environment.ENV_ACTIVE_PROFILE !== environment.ON_CUSTOMIDP) return false;
    const token = localStorage.getItem('access_token');
    if (!token) return false;
    const tokenSetTime = localStorage.getItem('token_set_time');
    const expiresIn = localStorage.getItem('expires_in');
    if (!tokenSetTime || !expiresIn) return true;
    const tokenAge = Math.floor(Date.now() / 1000) - parseInt(tokenSetTime, 10);
    return tokenAge < parseInt(expiresIn, 10) - 30;
  }

  redirectToEmployerPortalHome(): void {
    const base = environment.ON_CUSTOMIDP_Auth?.employerPortal;
    if (!base) return;
    // Some envs configure employerPortal as the bare origin
    // (`https://host/CustomerPortal`), others include `/home` already
    // (`https://host/CustomerPortal/home`). Strip trailing slash + an
    // optional trailing `/home` so we don't produce `/home/home`.
    const cleanBase = base.replace(/\/+$/, '').replace(/\/home$/, '');
    window.location.replace(cleanBase + '/home');
  }
}
